import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import Loader from "../../Loader";
import PopUp from "../../PopUp";
import {
  getGratuities,
  deleteGratuity,
} from "../../../services/apiSubPayments";
import moment from "moment";
import AddGratitutes from "./AddGratitutes";

const Gratuities = () => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [listResponse, setListResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({});

  const openDialog = () => {
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setSelectedRow(null);
    setErrors({});
    fetchListResponse();
  };
  const handleAddUser = (newUsers) => {
    fetchListResponse();
    setOpen(false);
  };
  const handleEdit = (row) => {
    setSelectedRow(row);
    setEditMode(true);
    openDialog();
  };
  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (item?._id) {
          try {
            let payload = {
              gratuityId: item?._id,
            };
            const response = await deleteGratuity(payload);
            setMessage("Gratuity deleted successfully");
            setOpenPopUp(true);
            fetchListResponse();
          } catch (error) {
            Swal.fire("Error deleting Role");
            fetchListResponse();
          }
        }
      }
    });
  };

  const NoRowsOverlay = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "gray",
      }}
    >
      <Typography>No Record Found</Typography>
    </Box>
  );

  const columns = [
    { field: "employee", headerName: "Employee", flex: 2 },
    { field: "amount", headerName: "Amount", flex: 2 },
    { field: "financialYear", headerName: "Financial Year", flex: 2 },

    {
      field: "actions",
      headerName: "Action",
      flex: 0,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon sx={{ fontSize: "19px" }} />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleDelete(params.row)}
          >
            <DeleteIcon sx={{ fontSize: "19px" }} />
          </IconButton>
        </>
      ),
    },
  ];

  // Generate an array of years (e.g., 2000 to 2030)
  const startYear = 2020;
  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index,
  );
  const [formData, setFormData] = useState({
    employee: "",
    financialYear: currentYear,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchListResponse = async () => {
    try {
      // setIsLoading(true);
      const payload = {
        ...formData,
        year: Number(formData.financialYear),
      };

      const response = await getGratuities(payload);
      console.log("getGratuities:", response?.gratuities);
      setListResponse(response?.gratuities);
      // setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch users", error);
      // setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchListResponse();
  // }, []);

  useEffect(() => {
    fetchListResponse();
  }, [formData]);

  return (
    <>
      <div className="row align-items-center m-3">
        <div className="col-lg-3 mb-3">
          <label className="form-label">Employee :</label>
          <input
            name="employee"
            type="text"
            className="form-control custom-input-styles"
            value={formData.employee}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <label className="form-label">Year :</label>

          <select
            name="financialYear"
            className="form-select vesselbox"
            aria-label="Default select example"
            onChange={handleChange}
            value={formData.financialYear}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-2">
          <div className="d-flex mb-3 mt-3">
            <button
              onClick={() => {
                openDialog();
              }}
              className="btn btna submit-button btnfsize"
            >
              Add Gratuities
            </button>
          </div>
        </div>
      </div>

      <AddGratitutes
        open={open}
        onAddUser={handleAddUser}
        onClose={handleClose}
        editMode={editMode}
        userSet={selectedRow}
        errors={errors}
        setErrors={setErrors}
      />
      <div className="m-3">
        <DataGrid
          rows={listResponse.map((item) => ({
            ...item,
            id: item._id,
            employee: item.employee || "N/A",
            amount: item.amount ?? "N/A",
            financialYear: item.financialYear ?? "N/A",
          }))}
          columns={columns}
          getRowId={(row) => row._id} // Use id field for unique row identification
          disableSelectionOnClick // Disables checkbox selection to prevent empty column
          disableColumnMenu // Removes column menu
          components={{
            NoRowsOverlay,
          }}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#eee !important", // Set gray background color
              color: "#000000", // Set white text color for contrast
              fontWeight: "bold", // Optional: Make the text bold
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            "& .MuiTablePagination-toolbar": {
              alignItems: "baseline", // Apply align-items baseline
            },
            "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "#eee", // Gray background for the footer
            },
          }}
          pagination // Enables pagination
          pageSizeOptions={[5, 10, 20, 50, 100]} // Sets available page size options
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10, // Default page size
                page: 0, // Default page index
              },
            },
          }}
        />
      </div>
      {listResponse?.length === 0 && (
        <div className="no-data">
          <p>No Data Found</p>
        </div>
      )}

      <Loader isLoading={isLoading} />

      {openPopUp && (
        <PopUp message={message} closePopup={() => setOpenPopUp(false)} />
      )}
    </>
  );
};

export default Gratuities;
